import {get} from "lodash";
import neoAnalyse from "@/components/analyse";
import NeoLoader from "@/components/loader";
import {getMonitoring} from "@/utils/functions";
import adverseMixin from "@/mixins/adverseMixin";
import printDataMixin from "@/mixins/printDataMixin";
import highlighterMixin from "@/mixins/highlighterMixin";
import {mapActions, mapGetters} from "vuex";
import axios from "@/axios";
import html2pdf from "html-to-pdf-js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import WorldCompliance from "./worldCompliance.vue";
import {EventBus} from "@/main.js";
import Loader from "@/components/loader";
import {DateTime} from "luxon";

export default {
    components: {
        neoAnalyse,
        NeoLoader,
        Loading,
        "neo-loader": Loader,
        WorldCompliance,
    },
    data() {
        return {
            urlFields: ["related url", "locationurl"],
            isPrintLoader: false,
            isMediaLoading: false,
            isMonitoringTab: false,
            fullview: false,
            tabs: [
                {
                    name: "Current",
                    value: "current",
                },
                {
                    name: "Old",
                    value: "old",
                },
            ],
            editFields: false,
        };
    },
    mixins: [printDataMixin, adverseMixin, highlighterMixin],
    props: {
        content: {
            type: Object,
        },
        isResultExpanded: {
            type: Boolean,
        },
        isSavedLoading: {
            type: Object,
            default: {},
        },
        isOldVersionSelected: {
            type: Boolean,
            default: false,
        },
        isComparisonModeOn: {
            type: Boolean,
            default: false,
        },
        showFullViewBtn: {
            type: Boolean,
            default: true,
        },
    },
    async mounted() {
        this.isMonitoringTab = this.$route.name === "monitoring";
        if (this.isComparisonModeOn) {
            setTimeout(async () => {
                this.content.detailsExpanded = false;
                await EventBus.$emit("showMoreData", {
                    ...this.content,
                    index: this.content.curr_index,
                    isOldVersion: !this.content.is_parent,
                });
                this.$refs[`${this.content.key}ComponentsRef`]?.handleExpandAll(true, false);
                this.highlightChanges();
            }, 100);
        }
    },
    watch: {
        adverseCard() {
            setTimeout(() => {
                this.highlightChanges();
            }, 100);
        },
    },
    computed: {
        ...mapGetters(["getEntitiesRelationsAttributesData"]),
        expandedCard: {
            get() {
                return this.content;
            },
            set(val) {
                this.content = val;
            },
        },
        isMedia() {
            return this.adverseCard?.doc.media && this.adverseCard?.doc.media.length > 0;
        },
        adverseCard() {
            return this.expandedCard?.api_all_data ?? {};
        },
        adverseCardKey() {
            return this.expandedCard?.key;
        },
        getSavedClasses() {
            let classes = "";
            if (this.isSavedLoading.loading && this.isSavedLoading.loadingCardIndex === this.content.api_all_data.doc_id) classes += " tw-opacity-40 tw-cursor-not-allowed ";
            if (this.content.api_all_data.saved) classes += " tw-text-blue-700 tw-font-semibold  tw-text-xs tw-bg-blue-200 ";
            else classes += " tw-bg-blue-200 tw-text-blue-800 ";
            return classes;
        },
        selectedTab() {
            return this.isOldVersionSelected ? "old" : "current";
        },

        otherIds() {
            return this.expandedCard.api_all_data.OtherID.split(";");
        },

        getOtherID: {
            get() {
                return this.expandedCard.api_all_data.OtherID;
            },
            set(val) {
                this.expandedCard.api_all_data = {
                    ...this.expandedCard.api_all_data,
                    OtherID: val,
                };
            },
        },

        getAddress: {
            get() {
                return this.expandedCard.api_all_data.Address.map((add) => this.getFormattedAddress(add)).join(";");
            },
        },
    },
    methods: {
        ...mapActions(["setSelectedEntityData", "showAddEntityPanel"]),
        get,
        getFormattedAddress(res) {
            let add = [];
            if (res?.address?.length) {
                add.push(res.address);
            }
            if (res.city?.length) {
                add.push(res.city);
            }
            if (res.country?.length) {
                add.push(res.country);
            }
            if (res.postalcode?.length) {
                add.push(res.postalcode);
            }
            return add.join(",");
        },
        getFormattedName(name, result) {
            console.log(result);
            if (result.entry_type == "Individual") {
                if (name.split(",")[1] && name.split(",")[0]) {
                    return name.split(",")[1] + " " + name.split(",")[0].trim();
                } else if (name.split(",")[1] && !name.split(",")[0]) {
                    return name.split(",")[1];
                } else if (!name.split(",")[1] && name.split(",")[0]) {
                    return name.split(",")[0];
                }
            } else {
                return name;
            }
        },
        getIdentifierMapping(key, idx) {
            let mapping = "";
            switch (this.adverseCardKey) {
                case "lexisBridger":
                    if (key === "name") mapping = "['data']['EntityDetails']['Name']['Full']";
                    else if (key === "address")
                        mapping = `['data']['Address'][${idx}]['address'] 
                        ['data']['Address'][${idx}]['city'] 
                        ['data']['Address'][${idx}]['country'] 
                        ['data']['Address'][${idx}]['postalcode']`;
                    break;
            }
            return mapping;
        },

        getFormattedTime(ts, format) {
            let date = DateTime.fromISO(ts);
            return format ? date.toFormat(format) : date.toFormat("EEE, dd MMM yyyy, hh:mm:ss a");
        },
        parseTypes(data) {
            if (data?.trim()) return data?.split(",")?.map((e) => e.replace(/-/g, " ")?.replace(/None/g, "Others"));
            else return [];
        },
        getEntityType(result) {
            const type = result.api_all_data.EntryType;
            const key = result.key;
            if (key === "worldCompliance") {
                if (type === "Individual") return type;
                else return "Business";
            } else {
                return type;
                // if (type === "Individual" || ) return "Person";
                // else return "Company";
            }
        },
        changedResult(og_value, key, classes = false) {
            let result = {};
            let changeKey = get(this.adverseCard?.change_history ?? {}, key, []);
            if (changeKey.length) {
                result = this.getMonitoring(changeKey, og_value);
                return result;
            } else return {text: og_value};
        },
        async printDocuments(id, fileName, key, noPrint) {
            this.isPrintLoader = true;
            let htmlPDF = "";
            if (key == "worldCompliance") {
                htmlPDF = await this.$refs.lexisBridgerComponentsRef.printPageLexis(id, fileName, noPrint);
            }
            return htmlPDF;
        },
        updatePrintStatus() {
            this.isPrintLoader = !this.isPrintLoader;
        },
        handleResultSaveData(result) {
            EventBus.$emit("handleResultSave", result);
        },
        async createPDF() {
            document.getElementById("close-button").style.display = "none";
            [...document.querySelectorAll("#print-button")].forEach((print) => {
                print.style.display = "none";
            });

            const htmlContent = await this.printDocuments("printDataSection", this.expandedCard.name, this.expandedCard.key, true);

            [...document.querySelectorAll("#print-button")].forEach((print) => {
                print.removeAttribute("style");
            });

            document.getElementById("close-button").removeAttribute("style");

            this.isMediaLoading = true;

            let doc = null;

            await new Promise((resolve) =>
                setTimeout(async () => {
                    doc = await html2pdf()
                        .set({
                            margin: 5,
                            pagebreak: {
                                mode: ["avoid-all"],
                            },
                            filename: `${this.expandedCard.name}.pdf`,
                        })
                        .from(htmlContent)
                        .outputPdf("blob");
                    resolve({data: "your return data"});
                }, 1000)
            );

            const blobPDF = new Blob([doc], {type: "application/pdf"});
            const file = this.blobToFile(blobPDF, this.expandedCard.name);
            const formData = new FormData();
            formData.append("file", file);
            const response = await axios({
                url: "/uploads/reports/images",
                method: "post",
                data: formData,
            });
            this.showExpand = true;
            const screenshot = {
                available: true,
                location: response.data.file,
                file_name: response.data.file,
                file_mime_type: file.type,
                size: file.size,
            };
            return screenshot;
        },
        blobToFile(theBlob, fileName) {
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        },
        async onSaveMedia() {
            const screenshot = await this.createPDF();
            this.setSelectedEntityData({
                all_data: {
                    url: this.expandedCard.name,
                    add_graph: true,
                    screenshot,
                    raw_page_text: document.getElementById("printDataSection").innerText,
                },
                datatype: "passive_media",
                editEntity: true,
                entity: null,
                text: "",
                userDefined: true,
            });
            this.showAddEntityPanel();
            this.isMediaLoading = false;
        },
        onFullScreen(reset = false) {
            let elem = document.getElementById("result-expanded");
            if (reset) {
                elem.style.setProperty("width", "70%", "important");
            } else {
                elem.style.width = null;
            }
            if (elem) {
                elem.style.position = reset ? null : "absolute";
                elem.style.inset = reset ? null : "0";
                elem.style.padding = reset ? "0 0.5rem 0.5rem 0.5rem" : 0;
                elem.style.zIndex = reset ? null : "21";
            }

            let resElem = document.getElementById("result-list-wrapper");
            if (resElem) {
                resElem.style.borderRadius = reset ? "0.375rem" : 0;
                resElem.style.setProperty("height", "100%", "important");
            }

            let buttonToolbar = document.getElementById("button-toolbar");
            if (buttonToolbar) buttonToolbar.style.display = reset ? null : "none"; // 25

            let osintExpand = document.getElementById("osint--panel--drawer");
            if (osintExpand) osintExpand.style.display = reset ? null : "none"; //2020

            let monitoringDateRangeSlider = document.getElementsByClassName("monitoring-dateRange-slider");
            if (monitoringDateRangeSlider?.[0]) monitoringDateRangeSlider[0].style.display = reset ? null : "none"; //20

            this.fullview = !reset;
        },
        onClose() {
            if (this.fullview) {
                this.onFullScreen(true);
            } else {
                this.$emit("closeMoreInfo");
            }
        },
        getEntitySource(result) {
            if (result.entity_type.toLowerCase() === "person" || result.entity_type.toLowerCase() === "individual" || result.entity_type.toLowerCase() === "officer") return "name";
            else if (result.api_all_data.e_i && (result.api_all_data.e_i.toLowerCase() === "male" || result.api_all_data.e_i.toLowerCase() === "female")) return "name";
            else return "company_name";
        },

        setAddress(event) {
            const val = event?.target?.value;
            const address = val.split(";").map((add) => ({
                address: add.split(",")?.[0],
                city: add.split(",")?.[1],
                country: add.split(",")?.[2],
                postalcode: add.split(",")?.[3],
            }));
            this.expandedCard.api_all_data = {
                ...this.expandedCard.api_all_data,
                Address: address,
            };
        },
    },
};
